<h3 mat-dialog-title>
  <div class="title">
    <div>
      <button
        mat-icon-button
        matTooltip="Changer le logo de la société"
        aria-label="Changer le logo de la société"
        (click)="onClickChangeLogo()"
        [disabled]="isReadOnly"
      >
        <mat-icon>cloud_upload</mat-icon>
      </button>
      @if (selectedLogoPreviewUrl) {
        <img [src]="selectedLogoPreviewUrl" alt="Aperçu du logo sélectionné" class="company-logo" />
      } @else if (company && (hasCompanyLogo$ | async)) {
        <img
          [src]="companyLogoService.getLogoSrcUrl(company.id)"
          alt="Logo de {{ company.name }}"
          class="company-logo"
        />
      }
      <input
        #logoFileInput
        type="file"
        accept="image/png"
        hidden
        (change)="onLogoFileSelected($event)"
      />
    </div>

    <div [style.color]="color">
      @if (company) {
        {{ company.name }}
      } @else {
        <mat-form-field>
          <mat-label>Nom de l'entreprise</mat-label>
          <input matInput [formControl]="companyNameControl" />
        </mat-form-field>
      }
    </div>
    <div>
      <button
        mat-icon-button
        matTooltip="Choisir une couleur pour la société"
        aria-label="Choisir une couleur pour la société"
        (click)="toggleColorPicker = !toggleColorPicker"
        [disabled]="isReadOnly"
      >
        <div [(colorPicker)]="color" [(cpToggle)]="toggleColorPicker"></div>
        <mat-icon [style.color]="color">palette</mat-icon>
      </button>
    </div>
  </div>
</h3>
<mat-dialog-content>
  <section>
    <h5>Informations légales</h5>
    <app-legal-information-form
      [initWith]="$safeNavigationMigration(company?.legalInformation)"
    ></app-legal-information-form>
  </section>
  <section>
    <h5>Contacts</h5>
    <div class="flex gap">
      <mat-form-field class="w-100">
        <mat-label>Email de contact</mat-label>
        <input matInput [formControl]="emailControl" type="email" />
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label>Numéro de téléphone</mat-label>
        <input matInput [formControl]="phoneNumberControl" type="tel" />
      </mat-form-field>
    </div>
  </section>
  <section>
    <h5>Disque réseau</h5>
    <mat-form-field class="w-100" subscriptSizing="dynamic">
      <mat-label>Dossier réseau</mat-label>
      <input matInput [formControl]="vanexNetworkFolderNameControl" placeholder="7_VB Propreté" />
      <mat-hint data-test="vanex-network-folder-hint">
        Nom du dossier de la société dans le dossier POLE SOCIAL du disque réseau de Vanex (Z:), tel
        qu'il apparaît, préfixe compris.
      </mat-hint>
    </mat-form-field>
  </section>
  <section>
    <h5>Organisme de retraite complémentaire</h5>
    <app-postal-address-form [formGroup]="retraiteComplementaireForm"></app-postal-address-form>
  </section>
  <section>
    <h5>Organisme de prévoyance</h5>
    <app-postal-address-form [formGroup]="prevoyanceForm"></app-postal-address-form>
  </section>
  <section>
    <h5>Horaires collectifs</h5>
    <app-schedules-form
      [initWith]="initSchedulesFormValue"
      [readOnly]="isReadOnly"
    ></app-schedules-form>
  </section>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="dialogRef.close()">Fermer</button>
  <app-save-button
    (click)="onSave()"
    [isEditMode]="this.company ? true : false"
    [enabled]="isFormValid && !isReadOnly"
    matTooltip="Enregistrer les modifications"
  ></app-save-button>
</mat-dialog-actions>
